/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-01-21 11:03:47                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-21 14:23:47                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * RealmLayout: allow to choose realm
    * useEffect: check if user connected
*/

/* Imports */
import { useState } from "react";
/***/

/* Components */
import RealmSelector from "./RealmSelector";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { initKeycloak } from "../../services/auth/keycloak";
import { router } from "../../router/router";
import { RouterProvider } from "react-router-dom";
/***/

/**
* RealmLayout: allow to choose realm
* @param children - children element
*/
export default function RealmLayout({
  children
}: {
  children?: JSX.Element
}) {
  const [realm, setRealm] = useState<string | null>(localStorage.getItem("realm"));

  const keycloakInitOptions = {
    onLoad: "check-sso",
    silentCheckSsoFallback: true,
    checkLoginIframe: false,
    pkceMethod: "S256",
    tokenMinValidity: 30
  };

  
  return(
    <>
      {!realm ?
        <div className="w-[100vw] h-[100vh] flex items-center justify-center">
          <div>
            <label>Choose realm:</label>
            <RealmSelector onChange={(r) => setRealm(r)}/>
          </div>
        </div>
      : 
        <ReactKeycloakProvider authClient={initKeycloak()} initOptions={keycloakInitOptions} >
            <RouterProvider router={router} />
        </ReactKeycloakProvider>
      }
    </>
  );
}
